import React from "react";
import { VoiceFormPolicyContext } from "./voiceFormRegistry";
import { DynamicFieldStatus } from "./voiceDynamicFormLogic";

interface VoiceDynamicFormPanelProps {
  policy: VoiceFormPolicyContext | null;
  fieldStatuses: Record<string, DynamicFieldStatus>;
  formError: string | null;
}

/** Right-side panel — same read-only field cells as the claim form (no duplicate inputs). */
const VoiceDynamicFormPanel: React.FC<VoiceDynamicFormPanelProps> = ({
  policy,
  fieldStatuses,
  formError,
}) => {
  const statusRows = Object.entries(fieldStatuses);
  const pairedRows = statusRows.filter(
    ([, st]) => !/description|address|notes/i.test(st.label)
  );
  const largeRows = statusRows.filter(([, st]) =>
    /description|address|notes/i.test(st.label)
  );

  const renderField = (
    name: string,
    st: DynamicFieldStatus,
    size: "default" | "large"
  ) => (
    <div key={name} className={`field-cell field-cell--${size}`}>
      <div className="field-label">{st.label}</div>
      <div className={`field-value ${st.status}`}>{st.value}</div>
    </div>
  );

  return (
    <section className="field-group" aria-label="Dynamic form fields">
      {policy && (
        <p className="claim-section-meta">
          Policy: {policy.carrierPolicyNo}
        </p>
      )}
      {formError ? (
        <p className="claim-section-error">{formError}</p>
      ) : null}
      <div className="claim-fields-layout">
          <div className="field-pairs">
            {Array.from({ length: Math.ceil(pairedRows.length / 2) }).map(
              (_, rowIndex) => (
                <div key={rowIndex} className="field-pair-row">
                  {pairedRows
                    .slice(rowIndex * 2, rowIndex * 2 + 2)
                    .map(([name, st]) => renderField(name, st, "default"))}
                </div>
              )
            )}
          </div>
          <div className="field-stack-large">
            {largeRows.map(([name, st]) => renderField(name, st, "large"))}
          </div>
        </div>
    </section>
  );
};

export default VoiceDynamicFormPanel;
